import CoreAPI from "manifest-core/api/coreAPI";
import APIAuth from "manifest-core/api/employerDashboard/APIAuth";
import APIUser from "manifest-core/api/employerDashboard/APIUser";
import APICompany from "manifest-core/api/employerDashboard/APICompany";
import APILaunchDetails from "manifest-core/api/employerDashboard/APILaunchDetails";
import APIPlan from "manifest-core/api/employerDashboard/APIPlan";
import APITeam from "manifest-core/api/employerDashboard/APITeam";
import APIResource from "manifest-core/api/employerDashboard/APIResource";
import APIOrder from "manifest-core/api/employerDashboard/APIOrder";
import APIMetrics from "manifest-core/api/employerDashboard/APIMetrics";
import APIHRIntegration from "manifest-core/api/employerDashboard/APIHRIntegration";
import { envVariables, isLocalEnvironment } from "../env";
import Authentication from "./authentication";
import Session from "./session";

const coreAPI = new CoreAPI({
  useSentry: !isLocalEnvironment(),
  getSessionToken() {
    return Session.accessToken;
  },
  employerSearchUrl: "",
  baseUrl: `${envVariables.REACT_APP_API_BASE_URL}`,
  authorizedCheck() {
    return Authentication.verify();
  },
  redirectAndThrowError: () => {
    Authentication.clear();
    window.location.href = "/error";
    throw new Error("Requires Authentication");
  },
});

const API = {
  auth: APIAuth(coreAPI),
  metrics: APIMetrics(coreAPI),
  company: APICompany(coreAPI),
  launchDetails: APILaunchDetails(coreAPI),
  plan: APIPlan(coreAPI),
  team: APITeam(coreAPI),
  user: APIUser(coreAPI),
  resources: APIResource(coreAPI),
  orders: APIOrder(coreAPI),
  hrIntegration: APIHRIntegration(coreAPI),
};

export default API;
